import React from 'react';

export default function(props) {
    return (
        <>
            <h4 className="text-center main-top-heading">
                { props.text }
            </h4>
            { props.children }
        </>
    );
}
